import { Component, Input } from '@angular/core';

@Component({
  selector: 'rt-icon-translate-01',
  standalone: true,
  templateUrl: './rt-icon-translate-01.component.html',
  styleUrls: ['./rt-icon-translate-01.component.scss']
})
export class RtIconTranslate01Component {
  @Input() width: number | string = 17;
  @Input() height: number | string = 15;
}
